import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../../app/api/apiSlice";

const unitTemplatesAdapter = createEntityAdapter({});

const initialState = unitTemplatesAdapter.getInitialState();

export const unitTemplatesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUnitTemplates: builder.query({
      query: () => "/unitTemplates",
      validateStatus: (response, result) => {
        return response.status === 200 && !result.isError;
      },
      // keepUnusedDataFor: 5,
      transformResponse: (responseData) => {
        const loadedUnitTemplates = responseData.map((unitTemplate) => {
          unitTemplate.id = unitTemplate._id;
          return unitTemplate;
        });
        return unitTemplatesAdapter.setAll(initialState, loadedUnitTemplates);
      },
      providesTags: (result, error, arg) => {
        if (result?.ids) {
          return [
            { type: "UnitTemplate", id: "LIST" },
            ...result.ids.map((id) => ({ type: "UnitTemplate", id })),
          ];
        } else return [{ type: "UnitTemplate", id: "LIST" }];
      },
    }),
    addNewUnitTemplate: builder.mutation({
      query: (formData) => ({
        url: "/unitTemplates",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: [{ type: "UnitTemplate", id: "LIST" }],
    }),
    updateUnitTemplate: builder.mutation({
      query: (initialUnitTemplateData) => ({
        url: "/unitTemplates",
        method: "PATCH",
        body: {
          ...initialUnitTemplateData,
        },
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "UnitTemplate", id: arg.id },
      ],
    }),
    deleteUnitTemplate: builder.mutation({
      query: (id) => ({
        url: `/unitTemplates`,
        method: "DELETE",
        body: { id },
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "UnitTemplate", id: arg.id },
      ],
    }),
  }),
});

export const {
  useGetUnitTemplatesQuery,
  useAddNewUnitTemplateMutation,
  useUpdateUnitTemplateMutation,
  useDeleteUnitTemplateMutation,
} = unitTemplatesApiSlice;

// returns the query result object
export const selectUnitTemplatesResult =
  unitTemplatesApiSlice.endpoints.getUnitTemplates.select();

// creates memoized selector
const selectUnitTemplatesData = createSelector(
  selectUnitTemplatesResult,
  (unitTemplatesResult) => unitTemplatesResult.data // normalized state object with ids & entities
);

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
  selectAll: selectAllUnitTemplates,
  selectById: selectUnitTemplateById,
  selectIds: selectUnitTemplateIds,
  // Pass in a selector that returns the unitTemplates slice of state
} = unitTemplatesAdapter.getSelectors(
  (state) => selectUnitTemplatesData(state) ?? initialState
);
